var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAimsos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "480 341 644 497",
    style: {
      enableBackground: "new 0 0 1600 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.9767,
    y1: 471.5211,
    x2: 729.8956,
    y2: 931.9746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09E2AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B72FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1120.01,802.69L880.38,387.64c-16.78-29.06-46.83-46.41-80.38-46.41c-33.55,0-63.6,17.35-80.38,46.41 L479.99,802.69c-4.22,7.31-4.22,16.32,0,23.64c4.22,7.31,12.03,11.82,20.47,11.82h119.81c8.45,0,16.25-4.51,20.47-11.82 l99.34-172.07l78.87,136.61h-41.78c-7.86-12.37-21.64-20.62-37.35-20.62c-24.4,0-44.25,19.85-44.25,44.25s19.85,44.25,44.25,44.25 c15.71,0,29.49-8.25,37.35-20.62h82.72c8.45,0,16.25-4.51,20.47-11.82c4.22-7.31,4.22-16.32,0-23.64L760.56,595.17 c-4.22-7.31-12.03-11.82-20.47-11.82c-8.45,0-16.25,4.51-20.47,11.82l-112.99,195.7h-65.22l219.16-379.59 c8.23-14.26,22.97-22.77,39.43-22.77c16.46,0,31.2,8.51,39.43,22.77l219.16,379.59h-65.22l-154.21-267.1 c3.24-6.15,5.09-13.13,5.09-20.55c0-24.4-19.85-44.25-44.25-44.25s-44.25,19.85-44.25,44.25c0,23.79,18.89,43.21,42.46,44.16 l161.05,278.94c4.22,7.31,12.03,11.82,20.47,11.82h119.81c8.45,0,16.25-4.51,20.47-11.82 C1124.23,819.02,1124.23,810.01,1120.01,802.69z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAimsos);
export default __webpack_public_path__ + "static/media/logo_AIMSOS.e3c74a3a7b050fe1b4cfd88e52f16f93.svg";
export { ForwardRef as ReactComponent };